import React from 'react';
import TextWrapPhoto from '../Photos/TextWrapPhoto';
import './Chapters.scss';
import intelXeon from '../../Assets/intelXeon.svg';
//import photo1 from "../../assets/inline-textwrap1.png";
//edit url below or delete below if importing photo above.

function Chapter8() {
  const photoData = {
    imgSrc: intelXeon,
    caption: '',
    float: 'right' //pass in "right" or "left"
  };

  return (
    <section className="chapter">
      <div>
        <TextWrapPhoto photoData={photoData} />
        <p className="chapter__paragraph">
          Sunlight.io and Pathr.ai are part of a community of software startups developing AI
          applications and infrastructure platforms at the edge and beyond. With the support of
          Lenovo’s new AI Innovators program—and Lenovo edge servers equipped with 3rd Gen Intel®
          Xeon® Scalable processors with built-in AI acceleration—these startups are improving lives
          without sacrificing privacy or performance.
        </p>
      </div>
    </section>
  );
}

export default Chapter8;
